<app-loader [Parent]="this"></app-loader>
@if (Model) {
  <div>
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (OnSave)="Save()" ></app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Edit Space Allocation
          </p>
          <div class="panel-block" style="display: block;">
            @if (Model.IsAllocationAdjustable) {
              <div>
                <div class="field">
                  <label class="label">{{Model.ParkingLot1Name}}</label>
                  <div class="control">
                    <input type="number" class="input" [min]="0" [max]="originalTotal"
                      [formControl]="parkingLot1Control"
                      (input)="onNumberInputChange($event, 0)" (change)="onSpaceAllocationChange($event, 0)">
                      <div class="mt-2">
                        <input type="range" class="slider is-fullwidth" style="width: 100%;" [min]="0" [max]="originalTotal"
                          [formControl]="parkingLot1Control"
                          (input)="onSpaceAllocationChange($event, 0)">
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">{{Model.ParkingLot2Name}}</label>
                      <div class="control">
                        <input type="number" class="input" [min]="0" [max]="originalTotal"
                          [formControl]="parkingLot2Control"
                          (input)="onNumberInputChange($event, 1)" (change)="onSpaceAllocationChange($event, 1)">
                          <div class="mt-2">
                            <input type="range" class="slider is-fullwidth" style="width: 100%;" [min]="0" [max]="originalTotal"
                              [formControl]="parkingLot2Control"
                              (input)="onSpaceAllocationChange($event, 1)">
                            </div>
                          </div>
                        </div>
                        <div class="notification is-primary mt-3">
                          Total spaces: {{originalTotal}}
                        </div>
                      </div>
                    } @else {
                      <div class="field">
                        <label class="label">{{Model.ParkingLot1Name}}</label>
                        <div class="control">
                          <input type="number" class="input" [formControl]="parkingLot1Control" readonly>
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">{{Model.ParkingLot2Name}}</label>
                        <div class="control">
                          <input type="number" class="input" [formControl]="parkingLot2Control" readonly>
                        </div>
                      </div>
                      <div class="notification is-primary mt-3">
                        Total spaces: {{originalTotal}}
                      </div>
                    }
                  </div>
                </article>
              </div>
            </div>
          </div>
        }